/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { useIntl } from 'react-intl';

import EmptyState from '@atlaskit/empty-state/empty-state';
import { Box } from '@atlaskit/primitives/compiled';
import { cssMap, jsx } from '@atlaskit/css';

import messages from './messages';
import PageNotFoundSVGUrl from '../assets/PageNotFoundSVG.svg';

const styles = cssMap({
	image: {
		maxWidth: '300px',
		width: '100%',
		height: '100%',
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
	},
});

const PageNotFoundSVG = () => {
	const { formatMessage } = useIntl();
	return (
		<img
			src={PageNotFoundSVGUrl}
			alt={formatMessage(messages.pageNotFoundImageAriaLabel)}
			width="476.06"
			height="482.63"
		/>
	);
};

// Due to the small width of the preview panel, we need to wrap the PageNotFoundSVG with specific styles
const PreviewPanelPageNotFoundSVG = () => {
	return (
		<Box xcss={styles.image}>
			<PageNotFoundSVG />
		</Box>
	);
};

type PageNotFoundEmptyStateProps = {
	embeddedConfluenceSource?: string;
};

export const PageNotFoundEmptyState = ({
	embeddedConfluenceSource,
}: PageNotFoundEmptyStateProps = {}): JSX.Element => {
	const { formatMessage } = useIntl();

	const isInPreviewPanel = embeddedConfluenceSource === 'confluence-page-preview-panel';
	const EmptyStateImage = isInPreviewPanel ? PreviewPanelPageNotFoundSVG : PageNotFoundSVG;
	const EmptyStateWidth = isInPreviewPanel ? 'narrow' : 'wide';

	return (
		<EmptyState
			header={formatMessage(messages.emptyStateHeader)}
			description={formatMessage(messages.emptyStateDescription)}
			width={EmptyStateWidth}
			renderImage={() => <EmptyStateImage />}
		/>
	);
};
